/* Backup Leaf : comportements de la page réécrits (aucun script du thème d'origine) */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var smooth = window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'auto';

  // ---------- bandeau : compte à rebours jusqu'à minuit, heure de Montréal ----------
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  var MTL = null;
  try { MTL = new Intl.DateTimeFormat('en-GB', { timeZone: 'America/Toronto', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }); } catch (e) {}
  function bfTick() {
    var el = document.getElementById('bf-time');
    if (el) {
      var now = new Date(), h, m, s;
      if (MTL) { var p = MTL.formatToParts(now), g = function (t) { for (var i = 0; i < p.length; i++) if (p[i].type === t) return +p[i].value; return 0; }; h = g('hour') % 24; m = g('minute'); s = g('second'); }
      else { h = now.getHours(); m = now.getMinutes(); s = now.getSeconds(); }
      var diff = 86400 - (h * 3600 + m * 60 + s); if (diff >= 86400) diff = 0;
      el.textContent = pad(Math.floor(diff / 3600)) + ':' + pad(Math.floor((diff % 3600) / 60)) + ':' + pad(diff % 60);
    }
    setTimeout(bfTick, 1000);
  }

  // ---------- bloc d'offres : minuteur 14:59 au chargement, disparaît à zéro ----------
  var mbLeft = 14 * 60 + 59, mbTimer = null;
  function mbRender() {
    $$('moonbundle-component .moonbundle-timer').forEach(function (t) {
      if (mbLeft <= 0) { t.style.display = 'none'; return; }
      var v = $$('.moonbundle-timer-value', t);
      if (v.length >= 2) { v[v.length - 2].textContent = pad(Math.floor(mbLeft / 60)); v[v.length - 1].textContent = pad(mbLeft % 60); }
    });
  }
  function mbTick() { if (mbLeft > 0) mbLeft--; mbRender(); if (mbLeft <= 0) clearInterval(mbTimer); }

  // ---------- bloc d'offres : sélection d'une offre (états pré-rendus) ----------
  function mbInit() {
    var mb = $('moonbundle-component'); if (!mb) return;
    mb.addEventListener('click', function (e) {
      var w = e.target.closest('.moonbundle-offer-wrapper');
      if (w) {
        var i = $$('.moonbundle-offer-wrapper', mb).indexOf(w);
        var cur = mb.getAttribute('data-lf-offer') || '0';
        if (i < 0 || String(i) === cur) return;
        var tpl = document.querySelector('template[data-lf-mb="' + i + '"]'); if (!tpl) return;
        var sc = $('.moonbundle-gift-block-scroll', mb), sl = sc ? sc.scrollLeft : 0;
        atcOut();
        mb.innerHTML = tpl.innerHTML;
        mb.setAttribute('data-lf-offer', String(i));
        var sc2 = $('.moonbundle-gift-block-scroll', mb); if (sc2) sc2.scrollLeft = sl;
        mbRender(); giftsInit(); fitTitle(); qtyImgs(); atcIn();
        return;
      }
      var ar = e.target.closest('.moonbundle-gift-block-scroll-arrow');
      if (ar) giftStep(ar.classList.contains('moonbundle-gift-block-scroll-arrow--prev') ? -1 : 1);
    });
    giftsInit();
  }
  var NEXT_HTML = '', PREV_HTML = '<button type="button" class="moonbundle-gift-block-scroll-arrow moonbundle-gift-block-scroll-arrow--prev svelte-vtkcgo" aria-label="Cadeaux précédents"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 6 9 12 15 18"></polyline></svg></button>';
  function giftsInit() {
    var sc = $('moonbundle-component .moonbundle-gift-block-scroll'); if (!sc) return;
    var nx = $('moonbundle-component .moonbundle-gift-block-scroll-arrow--next');
    if (nx && !NEXT_HTML) NEXT_HTML = nx.outerHTML;
    // état de départ de l'app : ni flèche ni dégradé, puis calcul sur la largeur réelle
    $$('moonbundle-component .moonbundle-gift-block-scroll-arrow').forEach(function (b) { b.remove(); });
    sc.parentElement.classList.remove('moonbundle-gift-block-scroll-clip--fade-left', 'moonbundle-gift-block-scroll-clip--fade-right');
    sc.addEventListener('scroll', giftUpd, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(giftUpd).observe(sc);
    requestAnimationFrame(giftUpd);
  }
  function giftUpd() {
    var sc = $('moonbundle-component .moonbundle-gift-block-scroll'); if (!sc) return;
    var clip = sc.parentElement, outer = clip.parentElement;
    var max = sc.scrollWidth - sc.clientWidth, can = max > 28, L = can && sc.scrollLeft > 2, R = can && sc.scrollLeft < max - 2;
    clip.classList.toggle('moonbundle-gift-block-scroll-clip--fade-left', L);
    clip.classList.toggle('moonbundle-gift-block-scroll-clip--fade-right', R);
    var pv = $('.moonbundle-gift-block-scroll-arrow--prev', outer), nx = $('.moonbundle-gift-block-scroll-arrow--next', outer);
    if (L && !pv) clip.insertAdjacentHTML('beforebegin', PREV_HTML);
    if (!L && pv) pv.remove();
    if (R && !nx && NEXT_HTML) clip.insertAdjacentHTML('afterend', NEXT_HTML);
    if (!R && nx) nx.remove();
  }
  function giftStep(dir) {
    var sc = $('moonbundle-component .moonbundle-gift-block-scroll'); if (!sc) return;
    var cols = $$('.moonbundle-gift-block-scroll-inner > .moonbundle-gift-column', sc); if (!cols.length) return;
    var J = sc.getBoundingClientRect(), i, r;
    if (dir > 0) { for (i = 0; i < cols.length; i++) { r = cols[i].getBoundingClientRect(); if (r.right > J.right + 2) { sc.scrollBy({ left: r.left - J.left, behavior: 'smooth' }); break; } } }
    else { var q = null; cols.forEach(function (c) { if (c.getBoundingClientRect().left < J.left - 2) q = c; }); if (q) sc.scrollBy({ left: q.getBoundingClientRect().left - J.left, behavior: 'smooth' }); }
    var done = false, fin = function () { if (!done) { done = true; giftUpd(); } };
    requestAnimationFrame(function () { requestAnimationFrame(giftUpd); });
    sc.addEventListener('scrollend', fin, { once: true }); setTimeout(fin, 500);
  }

  // ---------- galerie produit : diapos, miniatures, hauteur adaptée ----------
  function gallery() {
    var mc = $('media-carousel'); if (!mc) return;
    var dots = $('page-dots[aria-controls="' + mc.id + '"]') || $('page-dots');
    var items = [].slice.call(mc.children).filter(function (c) { return !c.hidden && c.nodeType === 1; });
    var thumbs = dots ? [].slice.call(dots.children) : [];
    var idx = Math.max(0, items.findIndex(function (s) { return s.classList.contains('is-selected'); })), prog = false, tm;
    function off() { return items.length < 2 ? 0 : items[1].offsetLeft - items[0].offsetLeft; }
    function height() { var s = items[idx]; if (s && mc.hasAttribute('adaptive-height') && s.clientHeight !== mc.clientHeight) mc.style.maxHeight = s.clientHeight + 'px'; }
    function selDot(i) {
      if (!dots || !thumbs[i]) return;
      var t = thumbs[i];
      dots.scrollTo({ left: t.offsetLeft - dots.clientWidth / 2 + t.clientWidth / 2, top: t.offsetTop - dots.clientHeight / 2 - t.clientHeight / 2, behavior: smooth });
      thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function settle() { items.forEach(function (s, k) { s.classList.toggle('is-selected', k === idx); }); height(); }
    mc.addEventListener('scroll', function () {
      clearTimeout(tm);
      tm = setTimeout(function () { prog = false; settle(); }, 90);
      if (prog) return;
      var o = off(); if (!o) return;
      var n = Math.max(0, Math.min(items.length - 1, Math.round(mc.scrollLeft / o)));
      if (n !== idx) { idx = n; selDot(n); }
    }, { passive: true });
    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (i === idx) return;
        idx = i; selDot(i); prog = true;
        mc.scrollTo({ left: off() * i, behavior: smooth });
      });
    });
    height();
    window.addEventListener('resize', height);
  }

  // ---------- ombre de défilement (bords des miniatures) ----------
  function scrollShadows() {
    $$('scroll-shadow').forEach(function (h) {
      var el = h.firstElementChild; if (!el) return;
      var s = document.createElement('s'); s.className = 'lf-ss'; s.setAttribute('aria-hidden', 'true'); h.appendChild(s);
      function upd() {
        var max = parseInt(getComputedStyle(h).getPropertyValue('--scroll-shadow-size'), 10) || 0;
        var v = { top: Math.max(el.scrollTop, 0), bottom: Math.max(el.scrollHeight - el.offsetHeight - el.scrollTop, 0), left: Math.max(el.scrollLeft, 0), right: Math.max(el.scrollWidth - el.offsetWidth - el.scrollLeft, 0) };
        requestAnimationFrame(function () { ['top', 'bottom', 'left', 'right'].forEach(function (p) { s.style.setProperty('--' + p, (v[p] > max ? max : v[p]) + 'px'); }); });
      }
      el.addEventListener('scroll', upd, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(upd).observe(el);
      upd();
    });
  }

  // ---------- accordéons : ouverture animée comme l'original ----------
  function anim(el, kf, opt) {
    var a = el.animate(kf, Object.assign({ fill: 'both' }, opt));
    return a.finished.then(function () { try { a.commitStyles(); } catch (e) {} a.cancel(); });
  }
  function accordions() {
    $$('details[is="accordion-disclosure"]').forEach(function (d) {
      var sum = d.firstElementChild, content = d.lastElementChild, open = d.hasAttribute('open'), busy = 0;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        open = !open; var my = ++busy;
        d.setAttribute('aria-expanded', open ? 'true' : 'false');
        d.style.overflow = 'hidden';
        var p;
        if (open) {
          d.setAttribute('open', '');
          p = Promise.all([
            anim(d, [{ height: sum.clientHeight + 'px' }, { height: d.scrollHeight + 'px' }], { duration: 250, easing: 'ease' }),
            anim(content, [{ opacity: 0, transform: 'translateY(0)' }, { opacity: 1, transform: 'translateY(-4px)' }], { duration: 150, delay: 150, easing: 'ease' })
          ]);
        } else {
          p = Promise.all([
            anim(content, [{ opacity: getComputedStyle(content).opacity }, { opacity: 0 }], { duration: 150, easing: 'ease' }),
            anim(d, [{ height: d.clientHeight + 'px' }, { height: sum.clientHeight + 'px' }], { duration: 250, easing: 'ease' })
          ]).then(function () { if (my === busy) d.removeAttribute('open'); });
        }
        p.then(function () { if (my !== busy) return; d.style.height = 'auto'; d.style.overflow = 'visible'; });
      });
    });
  }

  // ---------- barre d'achat collante ----------
  // barre collante : rappel de l'offre principale + vignette, bouton « CHOISIR L'OFFRE » pleine largeur dessous
  // (encadré 25 % plus grand que la 1re version ; chaque ligne de l'offre reste sur une ligne, taille réduite juste assez)
  function stickyOffer(qa) {
    if ($('.lf-sticky', qa)) return;
    [].slice.call(qa.children).forEach(function (c) { c.style.display = 'none'; });
    var st = document.createElement('style');
    // style allégé : une seule rangée (vignette, offre sur 2 lignes, petit bouton à droite), barre blanche collée en bas
    st.textContent = 'product-quick-add{padding:0!important;bottom:0!important;left:0!important;right:0!important;width:100%!important;border:0!important;background:none!important}'
      + 'product-quick-add .lf-sticky{display:flex;align-items:center;gap:10px;width:100%;padding:10px 16px calc(10px + env(safe-area-inset-bottom));background:#fff;border-radius:16px 16px 0 0;box-shadow:0 -6px 20px rgba(91,44,63,.08);border-top:1px solid #f1e6eb}'
      + 'product-quick-add .lf-sticky__top{display:flex;align-items:center;gap:10px;flex:1;min-width:0;margin:0}'
      + 'product-quick-add .lf-sticky img{flex:none;width:44px;height:44px;border-radius:8px;object-fit:cover;background:#fdf4fc;border:1px solid #f1e6eb}'
      + 'product-quick-add .lf-sticky__txt{flex:1;min-width:0;line-height:1.3;overflow:hidden}'
      + 'product-quick-add .lf-sticky__offer{font-weight:700;font-size:13px;color:#111;white-space:nowrap}'
      + 'product-quick-add .lf-sticky__offer b{font-weight:700;color:#5B2C3F}'
      + 'product-quick-add .lf-sticky__sub{margin-top:1px;font-size:11.5px;color:#8a6d7a;white-space:nowrap}'
      + 'product-quick-add .lf-sticky__go{flex:none;height:40px;padding:0 16px;border:0;border-radius:5.2px;background:#000;color:#fff;font-weight:700;font-size:12.5px;letter-spacing:.06em;cursor:pointer;white-space:nowrap}'
      + '@media screen and (max-width:389px){product-quick-add .lf-sticky{gap:8px;padding-left:12px;padding-right:12px}product-quick-add .lf-sticky__top{gap:8px}product-quick-add .lf-sticky img{width:36px;height:36px}product-quick-add .lf-sticky__go{padding:0 10px;font-size:11.5px;letter-spacing:.03em}}';
    document.head.appendChild(st);
    var row = document.createElement('div'); row.className = 'lf-sticky';
    row.innerHTML = '<div class="lf-sticky__top"><img src="' + QTY_IMG[1] + '" alt="" width="44" height="44">'
      + '<div class="lf-sticky__txt"><div class="lf-sticky__offer">2 ACHETÉS + 1 OFFERT <b>= 90 JOURS</b></div><div class="lf-sticky__sub">+ cadeaux et livraison offerts</div></div></div>'
      + '<button type="button" class="lf-sticky__go">VOIR L’OFFRE</button>';
    qa.appendChild(row);
    var fitOne = function (el, box) {
      el.style.fontSize = ''; var fs = parseFloat(getComputedStyle(el).fontSize) || 14;
      while (el.scrollWidth > box.clientWidth + 1 && fs > 9) { fs -= 0.25; el.style.fontSize = fs + 'px'; }
    };
    var fitSticky = function () {
      var box = $('.lf-sticky__txt', row); if (!box) return;
      fitOne($('.lf-sticky__offer', row), box); fitOne($('.lf-sticky__sub', row), box);
      // la page garde de la place en bas pour que la barre ne cache jamais la fin du pied de page
      document.body.style.paddingBottom = (qa.offsetHeight + 8) + 'px';
    };
    fitSticky(); window.addEventListener('resize', fitSticky);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSticky);
    $('.lf-sticky__go', row).addEventListener('click', function (e) {
      e.preventDefault();
      var mb = $('moonbundle-component'); if (!mb) return;
      var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
      window.scrollTo({ top: mb.getBoundingClientRect().top + window.scrollY - hh - 12, behavior: 'smooth' });
    });
  }
  // ligne « étoiles + 4,8/5 · 32 725 avis vérifiés » : +40 % (étoiles 65 → 91 px, texte 13 → 18,2 px)
  function bigRating() {
    var img = $('img[alt="Rating Stars"]'); if (!img) return;
    img.style.maxWidth = '91px';
    var txt = img.nextElementSibling; if (txt) { txt.style.fontSize = '18.2px'; txt.style.whiteSpace = 'nowrap'; }
  }
  // barre du bas : apparaît une fois le bouton AJOUTER AU PANIER des offres dépassé, reste jusqu'au pied de page
  function quickAdd() {
    var qa = $('product-quick-add'); if (!qa) return;
    stickyOffer(qa);
    var mb = $('button.button--xl') || $('moonbundle-component');
    if (!mb || !('IntersectionObserver' in window)) { qa.classList.add('is-visible'); return; }
    var io = new IntersectionObserver(function (en) {
      // visible seulement une fois le bouton AJOUTER AU PANIER dépassé (au-dessus de l'écran), y compris jusqu'au pied de page
      en.forEach(function (x) { qa.classList.toggle('is-visible', !x.isIntersecting && x.boundingClientRect.bottom < 0); });
    });
    io.observe(mb);
  }

  // ---------- témoignages : puces + flèches ----------
  function testimonials() {
    var grid = document.getElementById('leafTestimonialsGrid'); if (!grid) return;
    var dots = $$('#leafTestimonialsDots .leaf-testimonials__dot');
    var prev = document.getElementById('leafTestimonialsPrev'), next = document.getElementById('leafTestimonialsNext');
    var cards = $$('.leaf-testimonial-card', grid);
    if (dots.length) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting && x.intersectionRatio > 0.6) {
            var i = cards.indexOf(x.target);
            dots.forEach(function (d) { d.classList.remove('is-active'); });
            if (dots[i]) dots[i].classList.add('is-active');
          }
        });
      }, { root: grid, threshold: [0.6] });
      cards.forEach(function (c) { io.observe(c); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { var i = parseInt(d.dataset.index, 10); if (cards[i]) cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); });
      });
    }
    function by(dir) { grid.scrollBy({ left: dir * (cards[0].getBoundingClientRect().width + 18), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { by(-1); });
    if (next) next.addEventListener('click', function () { by(1); });
  }

  // ---------- titres découpés en lignes (rendu interne identique au thème) ----------
  function splitLines() {
    $$('split-lines').forEach(function (el) {
      if (el.shadowRoot || !el.attachShadow) return;
      var root = el.attachShadow({ mode: 'open' });
      function split() {
        root.innerHTML = el.textContent.replace(/./g, '<span>$&</span>').replace(/\s/g, ' ');
        var rows = new Map();
        [].slice.call(root.children).forEach(function (c) { var k = Math.round(c.getBoundingClientRect().top); rows.set(k, (rows.get(k) || '').concat(c.textContent)); });
        root.innerHTML = '';
        rows.forEach(function (line) { root.appendChild(document.createRange().createContextualFragment('\n      <span style="display: inline-block;">\n        <span style="display: block">' + line + '</span>\n      </span>\n    ')); });
      }
      split();
      var lw = window.innerWidth;
      window.addEventListener('resize', function () { if (window.innerWidth !== lw) { lw = window.innerWidth; split(); } });
    });
  }

  // ---------- apparitions au défilement (titre + cartes « Complétez votre routine ») ----------
  function inView(el, cb, margin) {
    if (!('IntersectionObserver' in window)) return cb();
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); cb(); } }, { rootMargin: margin });
    io.observe(el);
  }
  function reveals() {
    var S = window.LF_SETTINGS || {};
    var below = function (el) { return el.getBoundingClientRect().top > window.innerHeight; };
    $$('section-header').forEach(function (sh) {
      var h = $('h2[reveal-on-scroll="true"]', sh); if (!h || !below(sh)) return;
      var sl = $('split-lines', h), lines = sl && sl.shadowRoot ? [].slice.call(sl.shadowRoot.children) : [];
      if (!/^split/.test(S.headingApparition || '')) lines = [];
      if (lines.length) { h.style.opacity = '1'; lines.forEach(function (l) { l.style.opacity = '0'; }); }
      else h.style.opacity = '0';
      inView(sh, function () {
        if (lines.length) lines.forEach(function (l, k) { anim(l, [{ transform: 'translateY(0.5em)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 300, delay: k * 100, easing: 'ease' }); });
        else anim(h, [{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease' });
      }, '0px 0px -100px 0px');
    });
    if (!S.staggerProductsApparition) return;
    $$('reveal-items').forEach(function (r) {
      if (!below(r)) return;
      var sel = r.getAttribute('selector'), kids = sel ? $$(sel, r) : [].slice.call(r.children);
      r.style.opacity = '0';
      inView(r, function () {
        r.style.opacity = '1';
        var n = kids.length;
        kids.forEach(function (k, i) {
          // décalage 0,05 s réparti avec une courbe ease-out
          var t = n > 1 ? i / (n - 1) : 0, eo = 1 - Math.pow(1 - t, 2);
          anim(k, [{ opacity: 0, transform: 'translateY(15px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 350, delay: Math.round(eo * 0.05 * (n - 1) * 1000), easing: 'ease' });
        });
      }, r.getAttribute('margin') || '-50px 0px');
    });
  }

  // ---------- achat : offre choisie -> panier vidé -> ajout -> panier latéral -> paiement ----------
  // variantes du produit « Stick repulpant au PDRN » (boutique) dans l'ordre des offres 1, 2, 3
  var VARIANTS = ['49869705642055', '49869705609287', '49869705674823'];
  var PRICES = ['39,99', '79,98', '119,97'];
  // produits cadeaux (0 $, prix barré = valeur) ajoutés selon l'offre, comme les cadeaux débloqués du bloc d'offres
  var GIFT = { livraison: '49889513046087', masque: '49888755023943', patchs: '49888755187783', cou: '49888755286087', carte: '49888755417159' };
  // « Livraison gratuite » (camion, 0 $, barré 9,99 $) : seulement offres 2 et 3, comme sur la page
  var GIFTS = [[GIFT.masque], [GIFT.masque, GIFT.patchs, GIFT.livraison], [GIFT.masque, GIFT.patchs, GIFT.cou, GIFT.carte, GIFT.livraison]]; // livraison en dernier dans le panier
  function isGift(it) { return it.product_type === 'Cadeau' || (it.properties && it.properties._cadeau); }
  function offerIdx() {
    var mb = $('moonbundle-component'), i = parseInt(mb && mb.getAttribute('data-lf-offer'), 10);
    return i >= 0 && i < VARIANTS.length ? i : 1;
  }
  var buying = false;
  var post = function (url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body || {}) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  };
  function unbusy() { buying = false; $$('[aria-busy="true"]').forEach(function (b) { dots(b, false); }); }
  // bouton en chargement comme Leaf : le texte monte et s'efface, les 3 points arrivent par le bas et clignotent
  function dots(btn, on) {
    var txt = btn && btn.firstElementChild, ld = btn && $('.button__loader', btn);
    if (!txt || !ld || !txt.animate || txt === ld) { if (btn) { if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy'); } return; }
    if (on === (btn.getAttribute('aria-busy') === 'true')) return;
    var out = [{ transform: 'translateY(0)', opacity: 1, easing: 'ease' }, { transform: 'translateY(-10px)', opacity: 0, offset: 0.5, easing: 'ease' }, { transform: 'translateY(-10px)', opacity: 0 }];
    var inn = [{ transform: 'translateY(10px)', opacity: 0 }, { transform: 'translateY(10px)', opacity: 0, offset: 0.5, easing: 'ease' }, { transform: 'translateY(0)', opacity: 1 }];
    var o = { duration: 300, fill: 'forwards' };
    if (on) {
      btn.setAttribute('aria-busy', 'true');
      txt.animate(out, o); ld.animate(inn, o);
      [].slice.call(ld.children).forEach(function (s, i) { s.animate([{ opacity: 1 }, { opacity: 0.1 }], { duration: 350, delay: i * 350 / 3, easing: 'ease', iterations: Infinity, direction: 'alternate' }); });
    } else {
      btn.removeAttribute('aria-busy');
      ld.animate(out, o); txt.animate(inn, o);
    }
  }
  function buy(btn) {
    if (buying) return; buying = true;
    var o = offerIdx(), id = VARIANTS[o];
    var items = [{ id: +id, quantity: 1 }].concat(GIFTS[o].map(function (g) { return { id: +g, quantity: 1, properties: { _cadeau: '1' } }; }));
    try { sessionStorage.removeItem(RES_KEY); } catch (e) {}
    if (btn) dots(btn, true);
    // rapide : le panier s'ouvre tout de suite avec les infos produits déjà chargées, l'ajout réel se fait derrière
    var local = localCart(o);
    // (buying reste vrai jusqu'à la fin de l'ajout réel : pas de 2e ajout en parallèle ; les points restent jusqu'à l'ouverture complète du panier)
    if (local) { cartShow(local); setTimeout(function () { if (btn) dots(btn, false); }, 700); }
    // une seule offre dans le panier : on remplace ce qui s'y trouvait ; le bouton de paiement attend la fin (cartSync)
    cartSync = post('/cart/clear.js').then(function () { return post('/cart/add.js', { items: items }); })
      .then(function (res) {
        var its = (res && res.items) || [], cart = { items: its, item_count: its.length, total_price: its.reduce(function (s, it) { return s + it.final_line_price; }, 0) };
        return compareLoad(cart).then(function () { cartShow(cart); buying = false; if (!local) unbusy(); cartSync = null; });
      })
      // repli : lien panier direct, qui mène au paiement
      .catch(function () { window.location.href = '/cart/' + id + ':1'; });
  }
  var cartSync = null;
  // infos des produits de l'offre et des cadeaux, chargées à l'arrivée sur la page (pour ouvrir le panier sans attendre)
  var PROD = {};
  var HANDLES = ['pdrn-pink-collagen-multi-volume-balm-stick-anti-aging-firming-anti-wrinkle-for-eye-neck-forehead-smile-lines', 'cadeau-livraison-gratuite', 'cadeau-masque-collagene', 'cadeau-patchs-yeux', 'cadeau-masque-cou-decollete', 'cadeau-carte-cadeau'];
  function prefetchProducts() {
    HANDLES.forEach(function (h) {
      fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (p) {
        compareDone[h] = 1;
        (p.variants || []).forEach(function (v) {
          if (v.compare_at_price) COMPARE[v.id] = v.compare_at_price;
          var img = v.featured_image ? v.featured_image.src : (p.featured_image || '');
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          PROD[v.id] = { product_title: p.title, variant_title: v.title === 'Default Title' ? null : v.title, price: v.price, image: img, product_type: p.type };
        });
      }).catch(function () {});
    });
  }
  function localCart(o) {
    var ids = [VARIANTS[o]].concat(GIFTS[o]), items = [];
    for (var i = 0; i < ids.length; i++) {
      var d = PROD[ids[i]]; if (!d) return null;
      items.push({ variant_id: +ids[i], product_title: d.product_title, variant_title: d.variant_title, image: d.image, quantity: 1, original_line_price: d.price, final_line_price: d.price, product_type: d.product_type, properties: i ? { _cadeau: '1' } : {} });
    }
    return { items: items, item_count: items.length, total_price: items.reduce(function (s, it) { return s + it.final_line_price; }, 0) };
  }

  // ---------- panier latéral ----------
  var FREE_SHIP = 6000; // livraison gratuite dès 60 $ (zone Canada)
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' $'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var cartEl = null, openedAt = 0;
  // bouton du panier : 2e ligne « 30 jours de garantie » avec le bouclier, comme le bouton AJOUTER AU PANIER
  // 1re ligne comme le bouton Leaf : cadenas + texte en capitales espacées
  var GO_HTML = '<span class="lf-c__goline"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke-width="2" aria-hidden="true"><path d="M3.236 18.182a5.071 5.071 0 0 0 4.831 4.465 114.098 114.098 0 0 0 7.865-.001 5.07 5.07 0 0 0 4.831-4.464 23.03 23.03 0 0 0 .165-2.611c0-.881-.067-1.752-.165-2.61a5.07 5.07 0 0 0-4.83-4.465c-1.311-.046-2.622-.07-3.933-.069a109.9 109.9 0 0 0-3.933.069 5.07 5.07 0 0 0-4.83 4.466 23.158 23.158 0 0 0-.165 2.609c0 .883.067 1.754.164 2.61Z" fill="currentColor" fill-opacity=".12" stroke="currentColor"/><path d="M17 8.43V6.285A5 5 0 0 0 7 6.286V8.43" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 17.714a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Z" stroke="currentColor"/></svg>MAGASINER</span>'
    + '<span style="display:block;margin-top:4px;font-size:13px;font-weight:500;letter-spacing:normal;text-transform:none;opacity:.9">'
    + '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px;margin-right:6px"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>30 jours de garantie</span>';
  function cartBuild() {
    if (cartEl) return cartEl;
    var st = document.createElement('style');
    // présentation du panier Leaf : panneau blanc arrondi à 8 px des bords, voile gris 40 %, typo Bricolage Grotesque / Poppins
    st.textContent = '#lf-cart{position:fixed;inset:0;z-index:2147483001;visibility:hidden;font-family:"Bricolage Grotesque",sans-serif;font-size:14px;line-height:1.6;color:#000}#lf-cart.is-open{visibility:visible}'
      + '#lf-cart .lf-c__bg{position:absolute;inset:0;background:rgba(0,0,0,.4)}'
      + '#lf-cart .lf-c__panel{position:absolute;top:8px;right:8px;bottom:8px;width:calc(100% - 16px);max-width:480px;background:#fff;color:#000;border-radius:6px;overflow:hidden;clip-path:inset(0 0 0 0 round 6px)}'
      + '#lf-cart .lf-c__in{display:flex;flex-direction:column;height:100%}'
      + '#lf-cart .lf-c__body{flex:1;min-height:0;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding:20px 24px}'
      + '#lf-cart .lf-c__head{display:flex;align-items:center;justify-content:space-between;gap:8px;padding-bottom:24px}'
      + '#lf-cart .lf-c__title{display:flex;align-items:center;gap:8px;margin:0;font-family:Poppins,sans-serif;font-size:18px;font-weight:700;line-height:1.4;text-transform:uppercase}'
      + '#lf-cart .lf-c__count{display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;padding:0 4px;border-radius:9999px;background:#000;color:#fff;font-family:"Bricolage Grotesque",sans-serif;font-size:11px;font-weight:700;line-height:1}'
      + '#lf-cart .lf-c__x{display:flex;width:24px;height:24px;padding:0;border:0;background:none;color:#000;cursor:pointer}'
      + '#lf-cart .lf-c__timer{margin:-8px 0 24px;padding:6px 12px;border-radius:4px;background:rgba(0,0,0,.05);font-size:13px;line-height:1.5;text-align:center;white-space:nowrap;overflow:hidden}#lf-cart .lf-c__timer b{font-variant-numeric:tabular-nums;white-space:nowrap}'
      + '#lf-cart .lf-c__lines{display:flex;flex-direction:column;gap:24px}'
      + '#lf-cart .lf-c__line{display:flex;align-items:flex-start;gap:20px}'
      + '#lf-cart .lf-c__img{width:80px;height:80px;flex:none;border-radius:4px;object-fit:cover}'
      + '#lf-cart .lf-c__info{flex:1;min-width:0;display:flex;flex-direction:column;align-items:flex-start;gap:2px}'
      + '#lf-cart .lf-c__name{font-weight:700;line-height:22.4px}'
      + '#lf-cart .lf-c__price{color:#1d1d1d;line-height:22.4px}#lf-cart .lf-c__price s{margin-left:8px;color:rgba(0,0,0,.7)}'
      + '#lf-cart .lf-c__badge{display:inline-flex;align-items:center;gap:6px;margin-top:10px;padding:3px 8px;border-radius:4px;background:rgba(0,0,0,.05);font-size:9px;font-weight:700;line-height:1.6}#lf-cart .lf-c__badge svg{flex:none}'
      + '#lf-cart .lf-c__empty{padding:40px 0;text-align:center;color:rgba(0,0,0,.7)}'
      + '#lf-cart .lf-c__foot{padding:16px 24px calc(24px + env(safe-area-inset-bottom));border-top:1px solid rgba(0,0,0,.12)}'
      + '#lf-cart .lf-c__normal{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:4px;color:rgba(0,0,0,.7)}#lf-cart .lf-c__normal s{color:rgba(0,0,0,.7)}'
      + '#lf-cart .lf-c__sub{display:flex;justify-content:space-between;align-items:baseline;gap:16px;margin-bottom:16px;color:#1f9d6b;font-family:Poppins,sans-serif;font-size:18px;font-weight:700;line-height:1.4;text-transform:uppercase}'
      + '#lf-cart .lf-c__go{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;min-height:60px;padding:10px 16px;border:0;border-radius:5.2px;background:#000;color:#fff;font-family:"Bricolage Grotesque",sans-serif;font-size:18px;font-weight:700;line-height:1.15;letter-spacing:2px;text-transform:uppercase;text-align:center;cursor:pointer}'
      + '#lf-cart .lf-c__goline{display:inline-flex;align-items:center;justify-content:center;gap:12px}#lf-cart .lf-c__goline svg{flex:none}'
      + '#lf-cart .lf-c__go[disabled]{opacity:.5}#lf-cart .lf-c__go .lf-c__dots{display:flex;gap:6px;padding:9px 0}#lf-cart .lf-c__go .lf-c__dots i{width:6px;height:6px;border-radius:50%;background:currentColor;animation:lfDot .35s ease infinite alternate}#lf-cart .lf-c__go .lf-c__dots i:nth-child(2){animation-delay:.117s}#lf-cart .lf-c__go .lf-c__dots i:nth-child(3){animation-delay:.233s}@keyframes lfDot{to{opacity:.1}}#lf-cart .lf-c__go:has(.lf-c__dots){opacity:1}'
      + '#lf-cart .lf-c__pays{display:flex;justify-content:center;gap:5px;margin-top:12px}#lf-cart .lf-c__pays svg{flex:0 1 38px;min-width:0;height:24px}'
      + '#lf-cart .lf-c__trust{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:8px;margin-top:24px}#lf-cart .lf-c__tr span{min-width:0;white-space:nowrap}'
      + '#lf-cart .lf-c__tr{display:flex;align-items:center;gap:6px;padding:8px;border-radius:4px;background:rgba(0,0,0,.05);color:#000;text-decoration:none;font-size:12px;line-height:1.25}'
      + '#lf-cart .lf-c__tr svg{flex:none;width:22px;height:22px}#lf-cart .lf-c__tr b{display:block;font-size:1.04em}';
    document.head.appendChild(st);
    cartEl = document.createElement('div'); cartEl.id = 'lf-cart'; cartEl.setAttribute('aria-hidden', 'true');
    cartEl.innerHTML = '<div class="lf-c__bg"></div><aside class="lf-c__panel" role="dialog" aria-label="Votre panier"><div class="lf-c__in">'
      + '<div class="lf-c__body"><div class="lf-c__head"><p class="lf-c__title">Panier<span class="lf-c__count"></span></p>'
      + '<button type="button" class="lf-c__x" aria-label="Fermer le panier"><svg viewBox="0 0 24 24" width="24" height="24" stroke-width="2" aria-hidden="true"><path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"/></svg></button></div>'
      + '<div class="lf-c__timer">⏳ Vos articles sont réservés pour <b class="lf-c__left">09 min 59 s</b></div>'
      + '<div class="lf-c__lines"></div>'
      + '<div class="lf-c__trust">'
      + '<a class="lf-c__tr" href="#retours"><svg viewBox="0 0 24 24" fill="none" stroke="#1f9d6b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg><span><b>30 jours</b>satisfaite ou remboursée</span></a>'
      + '<div class="lf-c__tr"><svg viewBox="0 0 24 24" fill="none" stroke="#1f9d6b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/><circle cx="12" cy="16" r="1.3"/></svg><span><b>Paiement sécurisé</b>données cryptées</span></div>'
      + '</div></div>'
      + '<div class="lf-c__foot"><div class="lf-c__normal"><span>Prix normal</span><s class="lf-c__ref"></s></div>'
      + '<div class="lf-c__sub"><span>Total</span><span class="lf-c__total"></span></div>'
      + '<button type="button" class="lf-c__go">' + GO_HTML + '</button>'
      + '<div class="lf-c__pays"></div>'
      + '</div></div></aside>';
    document.body.appendChild(cartEl);
    var pt = document.getElementById('lf-pay-icons'); if (pt) $('.lf-c__pays', cartEl).appendChild(pt.content.cloneNode(true));
    $('.lf-c__tr[href]', cartEl).addEventListener('click', cartClose);
    // un 2e tap rapide sur le bouton d'achat tombe sur le voile : on ne ferme pas pendant l'ouverture
    $('.lf-c__bg', cartEl).addEventListener('click', function () { if (Date.now() - openedAt > 700) cartClose(); });
    $('.lf-c__x', cartEl).addEventListener('click', cartClose);
    $('.lf-c__go', cartEl).addEventListener('click', function () {
      this.disabled = true; this.innerHTML = '<span class="lf-c__dots"><i></i><i></i><i></i></span>';
      // si l'ajout au panier tourne encore, on attend qu'il soit fini avant d'aller au paiement
      (cartSync || Promise.resolve()).then(function () { window.location.href = '/checkout'; });
    });
    $('.lf-c__body', cartEl).addEventListener('click', function (e) {
      var rm = e.target.closest('.lf-c__rm'); if (!rm) return;
      // retirer l'offre retire aussi ses cadeaux
      post('/cart/clear.js').then(cartRender);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cartClose(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted && cartEl) { var g = $('.lf-c__go', cartEl); g.disabled = false; g.innerHTML = GO_HTML; } });
    return cartEl;
  }
  function cartRender(cart) {
    var el = cartBuild(), items = cart.items || [], total = cart.total_price || 0, refAll = 0;
    // l'offre d'abord, puis ses cadeaux
    var order = GIFTS[GIFTS.length - 1], rank = function (it) { var k = order.indexOf(String(it.variant_id)); return k < 0 ? 99 : k; };
    items = items.filter(function (it) { return !isGift(it); }).concat(items.filter(isGift).sort(function (a, b) { return rank(a) - rank(b); }));
    // étiquette grise avec l'icône d'étiquette, comme Leaf : offre « (-économie) » sous le stick, « Produit offert (-valeur) » sous chaque cadeau
    var TAG = '<svg viewBox="0 0 14 13" width="14" height="13" fill="none" stroke-width="1.5" aria-hidden="true"><path d="M7.25 11.383a1.74 1.74 0 0 0 2.195.105c.478-.35.957-.722 1.39-1.155.433-.433.804-.912 1.154-1.39.486-.662.45-1.588-.104-2.195a65.945 65.945 0 0 0-4.97-4.896 1.588 1.588 0 0 0-.75-.377c-1.017-.197-3.552-.613-4.177.012-.625.624-.208 3.16-.011 4.176.055.28.186.537.376.75a65.976 65.976 0 0 0 4.896 4.97Z" stroke="currentColor"/><path d="M5.729 5.227a1.036 1.036 0 1 0-1.466-1.466 1.036 1.036 0 0 0 1.466 1.466Z" fill="currentColor"/></svg>';
    var count = 0;
    $('.lf-c__lines', el).innerHTML = items.length ? items.map(function (it) {
      var gift = isGift(it);
      count += it.quantity;
      var img = it.image ? it.image + (it.image.indexOf('?') < 0 ? '?' : '&') + 'width=200' : '';
      var ref = Math.max(it.original_line_price, (COMPARE[it.variant_id] || 0) * it.quantity);
      refAll += ref;
      var off = ref - it.final_line_price;
      var was = off > 0 ? '<s>' + money(ref) + '</s>' : '';
      var label = gift ? (String(it.variant_id) === GIFT.livraison ? 'Livraison offerte' : 'Produit offert') : String(it.variant_title || '').toUpperCase();
      // l'offre choisie (nom de la variante = libellé des offres, ex. « 2 + 1 OFFERT = 90 JOURS ») s'affiche toujours, même sans réduction
      var badge = label && (off > 0 || !gift) ? '<span class="lf-c__badge">' + TAG + esc(label) + (off > 0 ? ' (-' + money(off) + ')' : '') + '</span>' : '';
      return '<div class="lf-c__line">' + (img ? '<img class="lf-c__img" src="' + esc(img) + '" alt="">' : '<span class="lf-c__img"></span>')
        + '<div class="lf-c__info"><div class="lf-c__name">' + esc(String(it.product_title || '').split(' | ')[0]).replace(/(\d) \$/g, '$1 $') + '</div>'
        + '<div class="lf-c__price">' + money(it.final_line_price) + was + '</div>' + badge
        + '</div></div>';
    }).join('') : '<p class="lf-c__empty">Votre panier est vide.</p>';
    $('.lf-c__trust', el).style.display = items.length ? '' : 'none';
    $('.lf-c__timer', el).style.display = items.length ? '' : 'none';
    $('.lf-c__count', el).textContent = count;
    $('.lf-c__total', el).textContent = money(total);
    // ligne « Prix normal » barrée, puis le total réduit en vert
    $('.lf-c__ref', el).textContent = money(refAll);
    $('.lf-c__normal', el).style.display = refAll > total ? '' : 'none';
    $('.lf-c__go', el).disabled = !items.length;
    $$('.cart-count, [data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
    return cart;
  }
  // ouverture et fermeture exactement comme Leaf (0,7 s) : voile en fondu, panneau dévoilé depuis la droite, contenu en fondu
  var CLIP_IN = 'inset(0 0 0 0 round 6px)', CLIP_OUT = 'inset(0 0 0 100% round 6px)', EASE = 'cubic-bezier(0.86, 0, 0.07, 1)';
  function cartAnim(open) {
    var el = cartEl, pan = $('.lf-c__panel', el), inn = $('.lf-c__in', el);
    [el, pan, inn].forEach(function (x) { if (x.getAnimations) x.getAnimations().forEach(function (a) { a.cancel(); }); });
    if (!el.animate) { if (!open) el.classList.remove('is-open'); return; }
    var o = { duration: 700 };
    if (open) {
      el.animate([{ opacity: 0, easing: 'ease' }, { opacity: 1, offset: 0.2143 }, { opacity: 1 }], o);
      pan.animate([{ clipPath: CLIP_OUT }, { clipPath: CLIP_OUT, offset: 0.2143, easing: EASE }, { clipPath: CLIP_IN, offset: 0.7857 }, { clipPath: CLIP_IN }], o);
      inn.animate([{ opacity: 0 }, { opacity: 0, offset: 0.7857, easing: 'ease' }, { opacity: 1 }], o);
    } else {
      el.animate([{ opacity: 1 }, { opacity: 1, offset: 0.7857, easing: 'ease' }, { opacity: 0 }], { duration: 700, fill: 'forwards' }).onfinish = function () {
        if (!el.classList.contains('lf-closing')) return;
        el.classList.remove('is-open', 'lf-closing');
      };
      pan.animate([{ clipPath: CLIP_IN }, { clipPath: CLIP_IN, offset: 0.2143, easing: EASE }, { clipPath: CLIP_OUT, offset: 0.7857 }, { clipPath: CLIP_OUT }], { duration: 700, fill: 'forwards' });
      inn.animate([{ opacity: 1, easing: 'ease' }, { opacity: 0, offset: 0.2143 }, { opacity: 0 }], { duration: 700, fill: 'forwards' });
    }
  }
  // minuteur toujours sur une ligne : taille réduite juste assez sur petit écran
  function fitTimer(el) {
    var t = $('.lf-c__timer', el); if (!t || t.style.display === 'none') return;
    t.style.fontSize = ''; var fs = 13;
    while (t.scrollWidth > t.clientWidth + 1 && fs > 9) { fs -= 0.25; t.style.fontSize = fs + 'px'; }
  }
  // vignettes côte à côte : texte réduit juste assez pour que chaque phrase tienne sur une ligne (même taille pour les deux)
  function fitTrust(el) {
    var sp = $$('.lf-c__tr span', el); if (!sp.length) return;
    var fs = 12, over = function () { return sp.some(function (x) { return x.scrollWidth > x.clientWidth + 1; }); };
    sp.forEach(function (x) { x.style.fontSize = fs + 'px'; });
    while (over() && fs > 8) { fs -= 0.25; sp.forEach(function (x) { x.style.fontSize = fs + 'px'; }); }
  }
  function cartShow(cart) {
    var el = cartBuild(), was = el.classList.contains('is-open') && !el.classList.contains('lf-closing');
    cartRender(cart); resStart(false);
    fitTimer(el); fitTrust(el);
    if (was) return; // déjà ouvert (mise à jour après l'ajout réel) : pas de 2e animation
    el.classList.remove('lf-closing'); el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden';
    $('.lf-c__body', el).scrollTop = 0;
    openedAt = Date.now(); cartAnim(true);
  }
  function cartOpen() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      return compareLoad(cart).then(function () { return cart; });
    }).then(cartShow);
  }
  // prix barrés : prix « avant » des variantes, lus sur la fiche produit de la boutique
  var COMPARE = {}, compareDone = {};
  function compareLoad(cart) {
    var hs = (cart.items || []).map(function (it) { return it.handle; }).filter(function (h, i, a) { return h && a.indexOf(h) === i && !compareDone[h]; });
    return Promise.all(hs.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (p) { compareDone[h] = 1; (p.variants || []).forEach(function (v) { if (v.compare_at_price) COMPARE[v.id] = v.compare_at_price; }); })
        .catch(function () {});
    }));
  }
  // réservation des articles : 9 min 59 s, relancée à chaque ajout au panier
  var RES_KEY = 'lfResEnd', resTimer = null;
  function resStart(reset) {
    var end = 0; try { end = +sessionStorage.getItem(RES_KEY) || 0; } catch (e) {}
    if (reset || !end) { end = Date.now() + 599000; try { sessionStorage.setItem(RES_KEY, end); } catch (e) {} }
    var tick = function () {
      var left = Math.max(0, Math.round((end - Date.now()) / 1000)), el = cartEl && $('.lf-c__left', cartEl);
      if (el) el.textContent = pad(Math.floor(left / 60)) + ' min ' + pad(left % 60) + ' s';
      if (!left) { clearInterval(resTimer); resTimer = null; }
    };
    clearInterval(resTimer); tick(); resTimer = setInterval(tick, 1000);
  }
  function cartClose() {
    if (!cartEl) return;
    if (!cartEl.classList.contains('is-open') || cartEl.classList.contains('lf-closing')) return;
    cartEl.classList.add('lf-closing'); cartEl.setAttribute('aria-hidden', 'true'); cartAnim(false);
    if (!$('dialog[open]') && !$('#lf-burger.is-open')) document.documentElement.style.overflow = '';
  }
  // prix de la barre d'achat collante = offre choisie
  function stickyPrice() {
    var NB = ' $';
    $$('product-quick-add sale-price').forEach(function (sp) { if (sp.lastChild) sp.lastChild.textContent = PRICES[offerIdx()] + NB; });
  }
  function buyInit() {
    stickyPrice();
    var mb = $('moonbundle-component');
    if (mb && 'MutationObserver' in window) new MutationObserver(stickyPrice).observe(mb, { attributes: true, attributeFilter: ['data-lf-offer'] });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { buying = false; $$('[aria-busy="true"]').forEach(function (b) { b.removeAttribute('aria-busy'); b.style.opacity = ''; }); } });
  }

  // ---------- liens inactifs (menus d'origine), boutons d'achat branchés ----------
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (a && a.getAttribute('href').charAt(0) !== '#') e.preventDefault();
    if (a && a.getAttribute('href') === '/cart') { cartOpen(); return; }
    var b = e.target.closest('button[type="submit"], [type="submit"]');
    if (b) { e.preventDefault(); if (/AJOUTER AU PANIER/i.test(b.textContent)) buy(b); }
  });
  document.addEventListener('submit', function (e) { e.preventDefault(); buy(); });

  // bouton « JE VEUX LES MÊMES RÉSULTATS » : défilement jusqu'au choix des offres
  document.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || !/JE VEUX LES M[ÊE]MES R[ÉE]SULTATS/i.test(b.textContent)) return;
    var mb = document.querySelector('moonbundle-component'); if (!mb) return;
    e.preventDefault();
    var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    window.scrollTo({ top: mb.getBoundingClientRect().top + window.scrollY - hh - 12, behavior: 'smooth' });
  });

  // ---------- titre du bloc d'offres sur une seule ligne (comme l'original), taille réduite au besoin ----------
  // minuteur « L'offre se termine dans » au-dessus des offres : retiré (demande Martin 26-10)
  function hideOfferTimer() {
    var st = document.createElement('style');
    st.textContent = 'moonbundle-component .moonbundle-bundle-timer{display:none!important}moonbundle-component .moonbundle-title{margin-bottom:20px}'
      // téléphone : badge « Économisez » toujours sous le titre de l'offre, au même niveau d'une offre à l'autre (sinon il remonte à côté de « 2 + 1 OFFERT » sur les grands écrans)
      + '@media screen and (max-width:699px){moonbundle-component .moonbundle-option-pills{flex-basis:100%}}';
    document.head.appendChild(st);
  }
  // ---------- offres : photo carrée de la quantité (1, 3, 6 sticks) entre le rond et le texte ----------
  var QTY_IMG = ['stick-1_unite.jpg', 'stick-3_unites.jpg', 'stick-6_unites.jpg'].map(function (f) { return 'https://cdn.shopify.com/s/files/1/0717/5176/1991/files/' + f + '?width=160'; });
  var QTY_DAYS = ['30 JOURS', '90 JOURS', '180 JOURS'];
  var qtyCss = false;
  function qtyImgs() {
    if (!qtyCss) {
      qtyCss = true;
      var st = document.createElement('style');
      st.textContent = 'moonbundle-component .moonbundle-option-details{align-items:center}'
        + 'moonbundle-component .moonbundle-option-checkbox{margin-right:0!important}'
        // photo 62 px (48 + 30 %), marges posées par fitOffers pour être à égale distance du rond et du texte
        + 'moonbundle-component .lf-qty{flex:none;align-self:center;width:62px;height:62px;margin:0 10px;border-radius:6px;object-fit:cover;background:#ebe7e4}'
        + 'moonbundle-component .moonbundle-option-subtitle{white-space:nowrap}'
        // colonne de prix serrée sur les prix (elle prenait 107 px pour 56 px de contenu) : la place va au texte
        + 'moonbundle-component .moonbundle-option-price{flex:0 0 auto!important;width:auto!important;margin-left:8px}'
        // badge « Économisez » : 12 px + 15 %
        + 'moonbundle-component .moonbundle-label-inside{font-size:13.75px!important}'
        // durée sur la même ligne que la quantité ; la taille du texte s'ajuste (fitOffers) pour que la ligne tienne
        + 'moonbundle-component .moonbundle-option-title{flex-wrap:nowrap;white-space:nowrap}'
        + 'moonbundle-component .lf-days{margin-left:5px;font-weight:600;color:#5B2C3F;white-space:nowrap}'
        + 'moonbundle-component .moonbundle-label-inside{white-space:nowrap}';
      document.head.appendChild(st);
    }
    $$('moonbundle-component .moonbundle-option-details').forEach(function (d, i) {
      if (!QTY_IMG[i] || $('.lf-qty', d)) return;
      var img = document.createElement('img'); img.className = 'lf-qty'; img.src = QTY_IMG[i]; img.alt = ''; img.width = 62; img.height = 62;
      var col = $('.moonbundle-option-col', d); d.insertBefore(img, col || null);
      // durée de la cure à côté du nom de l'offre
      var t = $('.moonbundle-option-title > span', d);
      if (t && QTY_DAYS[i]) { var s = document.createElement('span'); s.className = 'lf-days'; s.textContent = '= ' + QTY_DAYS[i]; t.insertAdjacentElement('afterend', s); }
    });
    mergeSavings();
    fitOffers();
  }
  // « Économisez xx % » fusionné dans l'étiquette du haut (« MEILLEUR VENDEUR · ÉCONOMISEZ 33 % ») ; le badge dans l'offre disparaît
  function mergeSavings() {
    $$('moonbundle-component .moonbundle-option-wrapper').forEach(function (w) {
      var lab = $('.moonbundle-label-inside', w), tag = $('.moonbundle-best-seller-block', w); if (!lab || !tag) return;
      var pills = lab.closest('.moonbundle-option-pills'); if (pills) pills.style.display = 'none';
      if (!$('.lf-tag-save', tag)) {
        var m = lab.textContent.match(/\d+\s*%/);
        if (m) { var s = document.createElement('span'); s.className = 'lf-tag-save'; s.textContent = ' · ÉCONOMISEZ ' + m[0].replace(/\s+/, ' '); tag.appendChild(s); }
      }
    });
  }
  // photo à égale distance du rond (bord du bouton radio, pas de sa boîte) et du texte
  var QTY_GAP = 12;
  function qtyGaps() {
    $$('moonbundle-component .moonbundle-option-details').forEach(function (d) {
      var img = $('.lf-qty', d), box = $('.moonbundle-option-checkbox', d), radio = box && $('input', box); if (!img || !radio) return;
      var slack = box.getBoundingClientRect().right - radio.getBoundingClientRect().right;
      img.style.marginLeft = Math.max(0, QTY_GAP - slack) + 'px'; img.style.marginRight = QTY_GAP + 'px';
    });
  }
  // une ligne par texte (« quantité = durée », « Livraison et cadeaux offerts ») : même taille pour les 3 offres,
  // taille voulue d'abord, réduite juste assez si la ligne ne tient pas
  function fitLines(sel, target, minFs) {
    var ts = $$(sel); if (!ts.length) return;
    ts.forEach(function (t) { t.style.fontSize = target + 'px'; });
    var k = 1;
    ts.forEach(function (t) { var c = t.closest('.moonbundle-option-col'), w = c ? c.clientWidth : 0; if (w && t.scrollWidth > w) k = Math.min(k, w / t.scrollWidth); });
    if (k < 1) { var fs = Math.max(minFs, Math.floor(target * k * 4) / 4); ts.forEach(function (t) { t.style.fontSize = fs + 'px'; }); }
  }
  // texte des offres +15 % (demande du 26-10, sur les 11 px affichés sur iPhone 15 Pro Max) ; les prix ne bougent pas
  function fitOffers() {
    qtyGaps();
    fitLines('moonbundle-component .moonbundle-option-title', 12.75, 10);
    fitLines('moonbundle-component .moonbundle-option-subtitle', 12.75, 9);
  }
  // ---------- sous la dernière offre (3 + 3), avant les cadeaux : bouton « AJOUTER AU PANIER », badges de paiement, phrase de stock ----------
  var atcBlocks = null;
  function atcIn() {
    if (!atcBlocks) {
      var pay = $('img.secure-pay-image'), stock = $('.custom-stock-container');
      atcBlocks = [$('[data-block-type="buy-buttons"]'), pay && pay.closest('.product-info__block-item'), stock && stock.closest('.product-info__block-item')].filter(Boolean);
    }
    var opts = $('moonbundle-component .moonbundle-options-horizontal'); if (!opts || !atcBlocks.length) return;
    var after = opts;
    atcBlocks.forEach(function (b, i) { b.style.margin = i ? '10px 0 0' : '16px 0 0'; after.parentNode.insertBefore(b, after.nextSibling); after = b; });
    atcBlocks[atcBlocks.length - 1].style.marginBottom = '28px';
    // 2e ligne dans le bouton : « 30 jours de garantie »
    var btn = atcBlocks[0] && $('button.button--xl', atcBlocks[0]), lab = btn && btn.firstElementChild;
    if (lab && !$('.lf-atc-sub', btn)) {
      var sub = document.createElement('span'); sub.className = 'lf-atc-sub';
      // bouclier avec un check devant le texte
      sub.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px;margin-right:6px"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>30 jours de garantie';
      sub.style.cssText = 'display:block;margin:0;font-size:13px;font-weight:500;letter-spacing:normal;text-transform:none;line-height:1.2;opacity:.9';
      lab.style.display = 'flex'; lab.style.flexDirection = 'column'; lab.style.alignItems = 'center'; lab.style.lineHeight = '1.15'; lab.style.gap = '4px';
      btn.style.height = 'auto'; btn.style.paddingBlock = '12px';
      lab.appendChild(sub);
    }
    // coins du bouton : 4 px d'origine + 30 % = 5,2 px
    if (!$('#lf-atc-radius')) {
      var st = document.createElement('style'); st.id = 'lf-atc-radius';
      st.textContent = '[data-block-type="buy-buttons"] .button{--button-border-radius:5.2px;border-radius:5.2px!important}[data-block-type="buy-buttons"] .button::before,[data-block-type="buy-buttons"] .button::after{border-radius:5.2px!important}';
      document.head.appendChild(st);
    }
  }
  // à sortir avant que le bloc d'offres soit redessiné (sinon ils disparaissent avec)
  function atcOut() {
    var mb = $('moonbundle-component'); if (!atcBlocks || !mb) return;
    var ref = mb.nextSibling;
    atcBlocks.forEach(function (b) { if (mb.contains(b)) mb.parentNode.insertBefore(b, ref); });
  }
  function fitTitle() {
    $$('moonbundle-component .moonbundle-title').forEach(function (h) {
      h.style.fontSize = ''; h.style.whiteSpace = 'nowrap';
      var fs = parseFloat(getComputedStyle(h).fontSize) || 14;
      while (h.scrollWidth > h.clientWidth + 1 && fs > 10) { fs -= 0.25; h.style.fontSize = fs + 'px'; }
    });
    fitOffers();
  }

  // ---------- pas de zoom : seulement le défilement ----------
  function noZoom() {
    var vp = $('meta[name="viewport"]');
    if (vp) vp.setAttribute('content', 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no');
    var st = document.createElement('style');
    st.textContent = 'html,body{touch-action:pan-x pan-y;-webkit-text-size-adjust:100%;text-size-adjust:100%}';
    document.head.appendChild(st);
    // Safari iOS ignore user-scalable=no : on bloque le pincement et le double appui
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (t) { document.addEventListener(t, function (e) { e.preventDefault(); }, { passive: false }); });
    document.addEventListener('touchmove', function (e) { if (e.touches && e.touches.length > 1) e.preventDefault(); }, { passive: false });
    var last = 0;
    document.addEventListener('touchend', function (e) {
      var now = Date.now();
      if (now - last < 300 && !e.target.closest('a, button, input, select, textarea, label, summary, [role="button"]')) e.preventDefault();
      last = now;
    }, { passive: false });
  }

  // ---------- menu burger (téléphone) : liens utiles de la page ----------
  function burger() {
    var btn = $('button[aria-controls="header-sidebar-menu"]'); if (!btn) return;
    var hh = function () { return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0; };
    var go = function (el) { if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - hh() - 12, behavior: 'smooth' }); };
    var ITEMS = [
      ['Accueil', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }],
      ['Le stick repulpant', function () { go($('moonbundle-component')); }],
      ['Avis clientes', function () { go($('.leaf-testimonials')); }],
      ['Livraison', '#livraison'],
      ['Retours et remboursements', '#retours'],
      ['Nous joindre', '#coordonnees']
    ];
    var st = document.createElement('style');
    st.textContent = '#lf-burger{position:fixed;inset:0;z-index:2147483000;visibility:hidden}#lf-burger.is-open{visibility:visible}'
      + '#lf-burger .lf-b__bg{position:absolute;inset:0;background:rgba(0,0,0,.45);opacity:0;transition:opacity .25s}#lf-burger.is-open .lf-b__bg{opacity:1}'
      + '#lf-burger .lf-b__panel{position:absolute;top:0;left:0;bottom:0;width:min(82vw,340px);background:#fff;color:#000;transform:translateX(-100%);transition:transform .25s ease;display:flex;flex-direction:column;padding:16px 0;overflow-y:auto}'
      + '#lf-burger.is-open .lf-b__panel{transform:none}'
      + '#lf-burger .lf-b__close{align-self:flex-end;margin:0 16px 8px;width:40px;height:40px;border:0;background:none;font-size:28px;line-height:1;cursor:pointer;color:#000}'
      + '#lf-burger a{display:block;padding:16px 24px;font-size:17px;font-weight:600;color:#000;text-decoration:none;border-bottom:1px solid #eee}';
    document.head.appendChild(st);
    var root = document.createElement('div'); root.id = 'lf-burger'; root.setAttribute('aria-hidden', 'true');
    root.innerHTML = '<div class="lf-b__bg"></div><nav class="lf-b__panel" aria-label="Menu"><button type="button" class="lf-b__close" aria-label="Fermer le menu">×</button></nav>';
    var nav = $('.lf-b__panel', root);
    ITEMS.forEach(function (it) {
      var a = document.createElement('a'); a.textContent = it[0];
      a.href = typeof it[1] === 'string' ? it[1] : '#lf-menu';
      a.addEventListener('click', function (e) { close(); if (typeof it[1] === 'function') { e.preventDefault(); setTimeout(it[1], 260); } });
      nav.appendChild(a);
    });
    document.body.appendChild(root);
    function open() { root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); btn.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden'; }
    function close() { root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); btn.setAttribute('aria-expanded', 'false'); if (!$('dialog[open]')) document.documentElement.style.overflow = ''; }
    btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    $('.lf-b__bg', root).addEventListener('click', close);
    $('.lf-b__close', root).addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  // hauteur réelle de l'en-tête (variable utilisée par les éléments collants), comme le thème
  function headerHeight() {
    var h = document.querySelector('.shopify-section--header, store-header'); if (!h) return;
    var set = function () { document.documentElement.style.setProperty('--header-height', Math.round(h.getBoundingClientRect().height) + 'px'); };
    set(); if ('ResizeObserver' in window) new ResizeObserver(set).observe(h);
  }
  function init() {
    headerHeight(); bfTick(); mbRender(); mbTimer = setInterval(mbTick, 1000);
    mbInit(); gallery(); scrollShadows(); accordions(); quickAdd(); testimonials(); splitLines(); reveals(); buyInit(); prefetchProducts(); bigRating(); noZoom(); burger(); hideOfferTimer(); fitTitle(); qtyImgs(); atcIn();
    var fw = window.innerWidth; window.addEventListener('resize', function () { if (window.innerWidth !== fw) { fw = window.innerWidth; fitTitle(); } });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
